<template>
  <v-container
      :id="id">
    <v-row justify="space-between">
      <v-col cols="4">
        <v-select
            :label="selectPrompt"
            :items="availableItems"
            item-title="title"
            item-value="value"
            density="compact"
            variant="outlined"
            v-model="selectedRadarItem"
            @update-data="onRadarChange"
        />
      </v-col>
      <v-col cols="6" v-show="availableItems2.length !== 0">
        <v-select
            :label="selectPrompt2"
            :items="availableItems2"
            item-title="title"
            item-value="value"
            density="compact"
            variant="outlined"
            v-model="selectedItem2"
        />
      </v-col>
      <v-col cols="2">
        <DownloadChartButton :id="`${id} - ${selectedRadarItem} ${selectedItem2 ?? ''}`" />
      </v-col>
    </v-row>
    <v-row
      align="center">
      <v-col cols="12">
        <SimpleRadarChart
            v-if="selectedRadarItem"
            :title="`${title} - ${StringManipulation.methods.clearAndCapitalize(selectedRadarItem)} level`"
            :chartData="chartData"
        />
      </v-col>
    </v-row>
    <slot name="chart_footer" />
</v-container>
</template>

<script setup>
import SimpleRadarChart from "../simple/SimpleRadarChart.vue";
import StringManipulation from "../../Mixins/StringManipulation";
import {computed, onMounted, ref, watch} from "vue";
import DownloadChartButton from "@/Charts/components/DownloadChartButton.vue";


const props = defineProps({
  title: {
    type: String,
    required: false,
    default: 'Untitled Chart'
  },
  selectPrompt: {
    type: String,
    required: false,
    default: 'Please select an item from the list'
  },
  selectPrompt2: {
    type: String,
    required: false,
    default: 'Please select an item from the list'
  },
  itemsData: {
    type: Object,
    required: true
  },
  itemsData2: {
    type: Object,
    required: false,
    default: null
  },
  id: {
    type: String,
    required: false
  }
})

const availableItems = computed(() => {
  return Object.keys(props.itemsData).sort().map(item => ({
    title: StringManipulation.methods.clearAndCapitalize(item),
    value: item
  }));
})

const selectedRadarItem = ref(availableItems.value[0]?.value)

const availableItems2 = computed(() => {
  if (!props.itemsData2 || !selectedRadarItem.value) return [];
  return Object.keys(props.itemsData2[selectedRadarItem.value] || {}).sort().map(item => ({
    title: StringManipulation.methods.clearAndCapitalize(item),
    value: item
  }));
})

const selectedItem2 = ref(null)

watch(availableItems2, (newItems) => {
  if (newItems.length > 0) {
    if (!selectedItem2.value || !newItems.find(i => i.value === selectedItem2.value)) {
      selectedItem2.value = newItems[0].value
    }
  } else {
    selectedItem2.value = null
  }
}, { immediate: true })

const chartData = computed(() => {
  if (props.itemsData2 && selectedRadarItem.value && selectedItem2.value) {
    return props.itemsData2[selectedRadarItem.value][selectedItem2.value]
  }
  return props.itemsData[selectedRadarItem.value]
})

onMounted(() => {
  const sortedKeys = Object.keys(props.itemsData).sort()
  if (sortedKeys.length > 0) {
    selectedRadarItem.value = sortedKeys[0]
  }
})

function onRadarChange(value) {
  selectedRadarItem.value = value
}
</script>

<style scoped>

</style>
